import { render, staticRenderFns } from "./RecursoCartaPrecatoria.vue?vue&type=template&id=6f445dce"
import script from "./RecursoCartaPrecatoria.vue?vue&type=script&lang=js"
export * from "./RecursoCartaPrecatoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports